import { createTheme } from '@mui/material/styles';
import type { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypeAction {
    disabledText: string;
  }
}

const getTheme = (mode: 'light' | 'dark'): ThemeOptions => ({
  palette: {
    mode,
    primary: {
      main: '#841617',
    },
    background: {
      default: mode === 'light' ? '#F0F0F0' : '#1e1e1e',
      paper: mode === 'light' ? '#FFFFFF' : '#1e1e1e',
    },
    text: {
      primary: mode === 'light' ? '#000000' : '#ffffff',
      secondary: mode === 'light' ? '#232F3E' : '#ffffff',
      disabled: mode === 'light' ? '#000000' : '#ffffff',
    },
    action: {
      disabled: '#888888',
      disabledText: mode === 'light' ? '#000000' : '#ffffff',
    },
    divider: '#C1C1C1',
    grey: {
      800: mode === 'light' ? '#232F3E' : '#ffffff',
      400: '#C1C1C1',
    },
  },
  typography: {
    fontFamily: 'Almari, Arial, sans-serif',
    h1: {
      fontFamily: 'Libre Baskerville, serif',
      fontWeight: 'bold',
      fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
      color: '#841617'
    },
    h2: {
      fontFamily: 'Libre Baskerville, serif',
      fontWeight: 'bold',
      fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
      color: '#841617'
    },
    h3: {
      fontFamily: 'Libre Baskerville, serif',
      fontWeight: 'bold',
      fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' },
      color: '#841617'
    },
    h4: { fontFamily: 'Libre Baskerville, serif', fontWeight: 'bold', color: '#841617' },
    h5: { fontFamily: 'Libre Baskerville, serif', fontWeight: 'bold', color: '#841617' },
    h6: { fontFamily: 'Libre Baskerville, serif', fontWeight: 'bold', color: '#841617' },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            minWidth: 44,
            minHeight: 44,
          },
        }),
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.main,
        }),
      },
    },
  },
});

export const lightTheme = createTheme(getTheme('light'));
export const darkTheme = createTheme(getTheme('dark'));
